import React from 'react';
import { getExerciseById } from '../../utils/mockData';
import { calculateWorkOutput, formatWorkOutput } from '../../utils/engineStub';
import Icon from '../shared/Icon';
import './ExerciseCard.css';

export default function ExerciseCard({ entry, onChange, onRemove, index }) {
  const exercise = getExerciseById(entry.exerciseId);
  const wo = calculateWorkOutput(entry);

  function update(field, value) {
    const parsed = field === 'weightLbs' || field === 'durationSec'
      ? parseFloat(value) || 0
      : parseInt(value, 10) || 0;
    onChange({ ...entry, [field]: parsed });
  }

  if (!exercise) return null;

  return (
    <div className="exercise-card">
      <div className="exercise-card__header">
        <span className="exercise-card__num">{index + 1}</span>
        <div className="exercise-card__name-group">
          <span className="exercise-card__name">{exercise.name}</span>
          <span className="exercise-card__category">{exercise.category}</span>
        </div>
        <span className="exercise-card__wo-mini">{formatWorkOutput(wo)}</span>
        <button className="exercise-card__remove" onClick={onRemove} aria-label="Remove exercise" type="button"><Icon name="close" size={14} /></button>
      </div>

      <div className="exercise-card__inputs">
        {entry.type !== 'cardio' && (
          <>
            <label className="exercise-card__input-group">
              <span className="exercise-card__input-label">Sets</span>
              <input
                className="exercise-card__input"
                type="number"
                min={1}
                max={20}
                value={entry.sets}
                onChange={(e) => update('sets', e.target.value)}
              />
            </label>
            <label className="exercise-card__input-group">
              <span className="exercise-card__input-label">Reps</span>
              <input
                className="exercise-card__input"
                type="number"
                min={0}
                max={100}
                value={entry.reps}
                onChange={(e) => update('reps', e.target.value)}
              />
            </label>
          </>
        )}

        {entry.type === 'strength' || entry.type === 'mixed' ? (
          <label className="exercise-card__input-group">
            <span className="exercise-card__input-label">lbs</span>
            <input
              className="exercise-card__input"
              type="number"
              min={0}
              step={2.5}
              value={entry.weightLbs}
              onChange={(e) => update('weightLbs', e.target.value)}
            />
          </label>
        ) : null}

        {entry.type === 'cardio' || entry.type === 'bodyweight' ? (
          <label className="exercise-card__input-group">
            <span className="exercise-card__input-label">sec</span>
            <input
              className="exercise-card__input"
              type="number"
              min={0}
              value={entry.durationSec || 0}
              onChange={(e) => update('durationSec', e.target.value)}
            />
          </label>
        ) : null}
      </div>

      <div className="exercise-card__muscles">
        {exercise.muscleGroups.map((m) => (
          <span key={m} className="exercise-card__muscle-tag">{m}</span>
        ))}
      </div>
    </div>
  );
}
